import { render, staticRenderFns } from "./AliasAddModal.vue?vue&type=template&id=2a118cdf&scoped=true&"
import script from "./AliasAddModal.vue?vue&type=script&lang=js&"
export * from "./AliasAddModal.vue?vue&type=script&lang=js&"
import style0 from "./AliasAddModal.vue?vue&type=style&index=0&id=2a118cdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a118cdf",
  null
  
)

export default component.exports